export default __webpack_public_path__ + "983a20d28fbf8fbc27cfeb096f0ebd85.woff2";